import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { VerfiyRequestByOtpComponent } from './verfiy-request-by-otp/verfiy-request-by-otp.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [VerfiyRequestByOtpComponent],
  imports: [CommonModule, ReactiveFormsModule,SharedModule],
  exports: [VerfiyRequestByOtpComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]

})
export class OtpModule {}